import { SiteExperienceConfig } from '../config/siteExperience';
import { withLocale } from '../i18n/standalone';

const API_BASE = window.location.hostname === 'localhost' ? 'http://chriscme/api' : '/api';

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  return res.json() as Promise<T>;
}

export async function fetchSiteExperience(retailerId: number | null, fresh = false): Promise<SiteExperienceConfig> {
  const query = retailerId ? `?retailer_id=${retailerId}` : '';
  const url = withLocale(`${API_BASE}/site-content.php${query}`);
  return handle<SiteExperienceConfig>(await fetch(url, { credentials: 'omit', cache: fresh ? 'no-store' : 'default' }));
}

export interface SiteExperienceRow {
  id: number;
  retailerId: number | null;
  menu: SiteExperienceConfig['menu'] | null;
  splash: SiteExperienceConfig['splash'] | null;
  isActive: boolean;
}

export interface SiteExperienceRetailer {
  id: number;
  name: string;
  isPartner: boolean;
  theme: Record<string, string> | null;
}

export interface AdminSiteExperienceResponse {
  rows: SiteExperienceRow[];
  retailers: SiteExperienceRetailer[];
  defaults: SiteExperienceConfig;
}

export async function fetchAdminSiteExperience(): Promise<AdminSiteExperienceResponse> {
  return handle<AdminSiteExperienceResponse>(await fetch(`${API_BASE}/admin-site-content.php`, { credentials: 'include' }));
}

export async function saveAdminSiteExperience(
  retailerId: number | null,
  config: SiteExperienceConfig,
): Promise<{ row: SiteExperienceRow }> {
  return handle<{ row: SiteExperienceRow }>(await fetch(`${API_BASE}/admin-site-content.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ retailerId, menu: config.menu, splash: config.splash }),
  }));
}

export async function resetAdminSiteExperience(retailerId: number | null): Promise<void> {
  const key = retailerId === null ? 'universal' : String(retailerId);
  await handle(await fetch(`${API_BASE}/admin-site-content.php?retailer_id=${encodeURIComponent(key)}`, {
    method: 'DELETE',
    credentials: 'include',
  }));
}
